<template>
 <div>
    <el-input ref="input" readonly :value="defaultValue" v-if="readonly"/>
    <el-select
      v-else
      v-model.trim="defaultValue"
      filterable
      remote
      clearable
      :placeholder="placeholder"
      :remote-method="getList"
      @visible-change="handleVisibleChange"
      @change="hendleChange"
      @clear="handleClear"
      :loading="loading">
      <el-option
        v-for="item in optionList"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
 </div>
</template>
<script>
import ProductApi from '@/api/product';
export default {
  name: 'PRODUCT_SELECTOR',
  props: {
    value: {
      type: String,
    },
    name: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择试用产品',
    },
    releaseStatus: {
      type: [String, Object],
      default: null,
    },
  },
  data () {
    return {
      optionList: [],
      loading: false,
      defaultValue: this.name,
    };
  },
  watch: {
    name: function (val) {
      if (val !== this.defaultValue) {
        this.defaultValue = val;
      }
    },
  },
  methods: {
    getList (keyword) {
      this.loading = true;
      ProductApi.getProductList({
        name: keyword,
        pageNum: 1,
        pageSize: 10,
        releaseStatus: this.releaseStatus,
      }).then(res => {
        this.optionList = res.body.list;
      }).finally(() => {
        this.loading = false;
      });
    },
    hendleChange (id) {
      let item = this.optionList.find(t => t.id === id);
      if (item) {
        this.$emit('input', item.id);
        this.$emit('update:name', item.name);
        this.$emit('change', item);
      }
    },
    handleClear () {
      this.$emit('input', '');
      this.$emit('update:name', '');
      this.$emit('change', {});
    },
    handleVisibleChange (visible) {
      if (visible) {
        this.getList();
      }
    },
  },
};

</script>
